<template>
  <ExternalList
      headline="Brands"
      endpoint="/api/v2/brands"
      :endpoint-filters="{portal_company_id: portalCompany.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-update="() => true"
      :can-destroy="() => true"
      reorder-endpoint="/api/v2/brands/priorities"
      :get-reorder-payload="data => ({brands: data})"
      @show="brand => $router.push(getUrl(brand))"
  >
    <template v-slot:default="{ row: brand }">
      <td>
        <router-link :to="getUrl(brand)">
          {{ brand.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ brand.attributes.url }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link class="btn btn-white btn-sm" style="margin-top: 4px;" to="brands/create">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {ExternalList},

  props: {
    portalCompany: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'URL'},
      ]
    }
  },

  methods: {
    getUrl(brand) {
      return '/companies/' + this.portalCompany.attributes.company_id + '/portals/' + this.portalCompany.id + '/brands/' + brand.id + '/edit'
    }
  }
}
</script>
